import React from 'react';
import {Button} from '@xpertdox_js/xdcomponents';
import styles from './styles';
import headerStyles from '../styles';
import { trackActivity } from '../../../../utils/activityTracker'
import { UserContext } from '../../../../Context/UserContext'
import { InstanceContext } from '../../../../InstanceContext'

const NativeButton = props => {

  const { user } = React.useContext(UserContext)
  const { contextInstance } = React.useContext(InstanceContext)
  const handleActivityLogUpdate = (_id) => {
    trackActivity({
      body: {
        _id,
        instance: contextInstance || user.instance,
        user: user.id
      }
    })
  }
  const openActionMenu = () => {
    console.log('activate')
    handleActivityLogUpdate(`NativeButton.openActionMenu`)
    !props.controller.groupMenuActive
    ? props.controller.setGroupMenuActive()
    : props.controller.setGroupMenuInactive();
  }
  const groupHasSelections = props.controller.group.length > 0;


   return(
    <React.Fragment>
       <Button
        onClick={openActionMenu}
        styles={groupHasSelections
          ? {...props.bufferStyles, ...styles.nativeBuffer}
          : props.bufferStyles
        }
        hoverStyles={styles.headerBufferHov}
        activeStyles={styles.headerBufferAct}
        focusStyles={styles.headerBufferFoc}
       >
        {props.data.id === 'dt_group_checkbox' &&
          <div style={groupHasSelections ? {...styles.groupCount, ...styles.groupCountAct} : styles.groupCount}>
            <span style={styles.groupCountText}>{props.controller.group.length}</span>
          </div>
        }
        <svg style={groupHasSelections ? {...styles.nativeSVG, ...styles.nativeSVGAct} : styles.nativeSVG} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M213.338 96H74.666C51.197 96 32 115.198 32 138.667v234.666C32 396.802 51.197 416 74.666 416h362.668C460.803 416 480 396.802 480 373.333V186.667C480 163.198 460.803 144 437.334 144H256.006l-42.668-48z"/></svg>
        <span style={headerStyles.headerSpacer}></span>
       </Button>
    </React.Fragment>
   )
}


export default NativeButton;
